import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';

import CRMApi from '../../../Api/CRM/CRMApi';
import Menu from '../../../Api/Models/Menu';
import useGlobalState from '../../GlobalStateContext';
import Card from '../../elements/common/Card';
import { SelectOptions } from '../../elements/formElements/Select';
import handleValidationErrors, { ValidationErrors } from '../../helpers/ResponseErrorHelper';
import { formatWithKey } from '../../helpers/formUtils';
import useBlockingSubmit from '../../hooks/useBlockingSubmit';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';
import useSmartField, { FieldChangeCallback } from '../../hooks/useSmartField';

export default function MenuUpdate() {
    const history = useHistory();
    const languageNames = formatWithKey(useGlobalState().languageNames);
    const { id } = useNumberParams();
    const [errors, setErrors] = useState<ValidationErrors>({});
    const [menu, setMenu] = useState<Menu>(new Menu({}));
    const [translatables, setTranslatables] = useState<SelectOptions>({});

    useOnce(() => {
        CRMApi.menus.getById(id).then(setMenu);
        CRMApi.menus.getTranslatableNames().then(formatWithKey).then(setTranslatables);
    });

    const handleFieldChange: FieldChangeCallback = (name, value) =>
        setMenu((prevMenu) => prevMenu.getNew({ [name]: value }));

    const Field = useSmartField({ errors, onChange: handleFieldChange });
    const [Submit, submitBlocked] = useBlockingSubmit();

    const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        try {
            await CRMApi.menus.update(menu);
            await swal({ title: 'Success', text: 'Menu updated correctly', icon: 'success' });
            history.push('/menus');
        } catch (error) {
            handleValidationErrors(error, setErrors);
            submitBlocked(false);
        }
    };

    return (
        <Card>
            <form onSubmit={handleFormSubmit}>
                <Field name="name" value={menu.name} />
                <Field name="slug" value={menu.slug} />
                <Field type="select" name="language_id" value={menu.language_id} options={languageNames} />
                <Field type="select" name="translation_id" value={menu.translation_id} options={translatables} />
                <Submit label="Update" />
            </form>
        </Card>
    );
}
